module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"link_back":"Назад"}}')
  delete Component.options._Ctor
}
